const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function tiktokNewProductReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_TIKTOK_NEW_PRODUCT':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_TIKTOK_NEW_PRODUCT':
			return {
				...state,
				list: action?.payload?.product_new_rank || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default tiktokNewProductReducer;
